import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ALL_CUSTOMER_FILES_RECEPTIONEST = "ALL_CUSTOMER_FILES_RECEPTIONEST";
export const ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING =
"ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING";
export const ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING_FAILED =
"ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const getAllCustomerFilesLoading = ms => ({
    type: ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING,
    payload: ms
    });
    
    export const getAllCustomerFilesLoadingFailed = ms => ({
    type: ALL_CUSTOMER_FILES_RECEPTIONEST_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function getAllCustomerFiles(obj) {
    if(obj.userId===undefined){
        var request = axios.get(
            `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/files/getUsersWithPagination?pageNo=${obj.pageNo}&limit=${obj.limit}`, {
                headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
              });
        
    }else{
        var request = axios.get(
            `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/files/getUsersWithPagination?userId=${obj.userId}&pageNo=${obj.pageNo}&limit=${obj.limit}`, {
                headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
              });
    }
    
    return dispatch => {

    dispatch(getAllCustomerFilesLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
   /*   console.log(response,"response getAllCustomerFiles") */
    dispatch({
    type: ALL_CUSTOMER_FILES_RECEPTIONEST,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        getAllCustomerFilesLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(getAllCustomerFilesLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(getAllCustomerFilesLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(getAllCustomerFilesLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


